/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AdoptionTypeIcon from 'icons/AppealsIcon';

const messages = defineMessages({
  title: {id: 'navigation.instructional-materials.appeals'},
});

const AppealsItem = () => (
  <RouteLinkItem
    iconBefore={AdoptionTypeIcon}
    route="midas/instructional-materials/appeals"
    title={messages.title}
  />
);

export default AppealsItem;
